export default __webpack_public_path__ + "static/media/mail-icon.25d4f83c.svg";